module.exports = __webpack_public_path__ + "img/Etihad-Airways.731a3084.jpg";